import { Component, OnInit } from '@angular/core';
import { Attachment } from 'app/models/attachment';
import { OAuthService } from 'app/services/o-auth';
import { DatePipe } from "@angular/common";
import { AngularFireDatabase } from 'angularfire2/database';
import { ActivatedRoute, Router } from '@angular/router';
import { AngularFireAuth } from 'angularfire2/auth';
import { FirebaseApp } from 'angularfire2';
import * as moment from "moment";
import { ApiService } from 'app/services/api';
import { ExcelService } from 'app/services/excel.service';

@Component({
  selector: 'app-raffle-detail',
  templateUrl: './raffle-detail.component.html',
  styleUrls: ['./raffle-detail.component.scss']
})
export class RaffleDetailComponent implements OnInit {
  public raffleID: any;
  constructor(
    private oAuthService: OAuthService,
    private datePipe: DatePipe,
    private route: ActivatedRoute,
    private router: Router,
    private firebase: FirebaseApp,
    private fireAuth: AngularFireAuth,
    private fireDatabase: AngularFireDatabase,
    private apiService: ApiService,
    private excelService: ExcelService  ) { }
  public raffle: any;
  public raffleId: any;
  public minFrom = new Date();
  public user: any;
  public isValidateMaxTicketPerUser: Boolean = false;
  public imageLoader: boolean = false;
  public raffleOrders = [];
  public winnerList = [];
  public totalAmount = 0;
  public winnerTicketId: any;
  public openWinnerModal = false;
  public openTicketModal = false;
  public totalAmountFromOrder = 0;
  public netAmountFromOrder = 0;
  public feeDeductedFromOrders = 0;

  public displayTickets = [];

  objectKeys = Object.keys;
  async ngOnInit() {
    $("#SelectWinner").modal("hide");
    $("#exampleModalCenter").modal("hide");
    this.user = this.oAuthService.getClub();
    this.raffleId = this.route.snapshot.paramMap.get("id");
    await this.getRaffle();
    await this.getRaffleOrders();
  }

  async getRaffle() {
    this.imageLoader = true;
    this.raffle = await this.apiService.object(`/raffles/${this.raffleId}`);

    if(this.raffle.winner) {
      let user = await this.apiService.object(`/users/${this.raffle.winner.userId}`);
      Object.assign(this.raffle.winner, { user: user });
    }

    this.raffle.startDate = new Date(this.raffle.startDate);
    this.raffle.endDate = new Date(this.raffle.endDate);
    this.raffle.drawDate = new Date(this.raffle.drawDate);
    this.imageLoader = false;
  }

  showTickits(order) {
    this.displayTickets = order.tickets;
  }

  async getRaffleOrders() {
    let raffleOrders = await this.apiService.list(`/raffles-user-ticket/${this.raffleId}`);
    let raffleList = [];
    let winnerList = [];
    this.totalAmountFromOrder = 0;
    this.feeDeductedFromOrders = 0;
    this.netAmountFromOrder = 0;
    for (let i = 0; i < raffleOrders.length; i++){
      let raffleOrdersTickets = raffleOrders[i]["orders"];
      for (let orderId in raffleOrdersTickets)
      {
        let element = raffleOrdersTickets["" + orderId];
        let payment = await this.apiService.object(`/user-payments/${raffleOrders[i].$key}/payments/${element.paymentId}`);
        let totalAmount = payment.amount;
        this.totalAmountFromOrder = this.totalAmountFromOrder + totalAmount/100;
        let orderFee = totalAmount * .029 + 20;
        this.feeDeductedFromOrders = this.feeDeductedFromOrders + orderFee/100;
        this.netAmountFromOrder = this.netAmountFromOrder + (totalAmount - orderFee)/100;
        let user = await this.apiService.object(`/users/${raffleOrders[i].$key}`);
        Object.assign(user, { userId: raffleOrders[i].$key})
        Object.assign(element, { payment: payment, user: user, $key: raffleOrders[i].$key, orderId: orderId});
        raffleList.push(element);
          for (let j = 0; j < element.tickets.length; j++){
            let ticketElement = JSON.parse(JSON.stringify(element));
            let ticket = element.tickets[j];
            let ticketObj = { ticketDisplayNo: "" + this.raffleId + "-" + this.numberWithLeadingZeroes(ticket.ticketNo), ticketId: ticket.tickitId, ticketNo: ticket.ticketNo };
            Object.assign(ticketElement, { ticket: ticketObj });
            delete ticketElement.tickets;
            winnerList.push(ticketElement);
        } 
      }
    }

    this.raffleOrders = raffleList;
    this.winnerList = winnerList;
  }

  onSelectWinner() {
    let foundWinner = false;
    if (this.winnerTicketId.length == 4) {
      let ticketDisplayNo = this.raffleId + "-" + this.winnerTicketId;
      for (let i = 0; i < this.winnerList.length; i++) {
        if (this.winnerList[i].ticket.ticketDisplayNo === ticketDisplayNo && this.winnerList[i].isCorrectAnswer) {
          foundWinner = true;

          if(confirm(`Do you want to declare ${ticketDisplayNo} ticket as winner ??`)){
            this.declareWinner(this.winnerList[i]);
          }
        }
      }
    }
    else alert("Please enter last 4 digits of ticket");

    if (!foundWinner) {
      alert("Please enter correct last 4 digits of ticket, or selected winner is rejected");
    }
   
  }

   validateOnlyNumber(event) {
    if (
      event.keyCode == 8 || //backspace
      event.keyCode == 37 || //left arrow
      event.keyCode == 39 || //right arrow
      event.keyCode == 46 || //delete
      (event.keyCode >= 48 && event.keyCode <= 57) ||
      (event.keyCode >= 96 && event.keyCode <= 105)
    ) {
      return true;
    }
    return false;
  }

   numberWithLeadingZeroes (n)
  {
      if ( n< 10 )
      {
          return ( '000' + n.toString () );
      }
      else if ( n< 100 )
      {
          return ( '00' + n.toString () );
      }
      else if ( n< 1000 )
      {
          return ( '0' + n.toString () );
      }
      else      {
          return ( n);
      }
   }
  
  onDownloadCSV() {
    // raffleOrders    
    let csvContent = "data:text/csv;charset=utf-8,";
    this.raffleOrders.forEach(function (order) {
      let rowData = [];
      rowData.push(""+order.payment.$key);
      rowData.push(""+order.user.username);
      rowData.push(""+order.user.fullName);
      rowData.push(""+order.user.email);
      rowData.push(""+order.tickets.length);
      rowData.push(""+new Date(order.payment.created).toDateString());
      rowData.push(""+order.payment.amount / 100);
      let row = rowData.join(",");
      csvContent += row + "\r\n";
    });
    var encodedUri = encodeURI(csvContent);
    window.open(encodedUri);
  }

  exportOrders() {
    // raffleOrders   
    let objectArray = [];
    this.raffleOrders.forEach(function (order) { 
      let object = { 
        orderId: order.payment.$key,
        username: order.user.username,
        fullName: order.user.fullName,
        email: order.user.email,
        tickets: order.tickets,
        created: new Date(order.payment.created).toDateString(),
        amount: order.payment.amount / 100      }
      objectArray.push(object);
    });
    this.excelService.exportAsExcelFile(objectArray, "export");
  }

  editRaffle() {
     this.router.navigateByUrl(
          `components/updateRaffle/${this.raffleId}`
        );
  }

  async declareWinner(winner) {
    let data = { ticket: winner.ticket, userId: winner.user.userId, paymentId: winner.paymentId, isCorrectAnswer: winner.isCorrectAnswer };
    await this.apiService.set(`/raffles/${this.raffleId}/winner`, data);
    location.reload();
  }
}

